var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 40,
    viewBox: "0 0 125 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.108 8.60001H61.288C60.168 8.60001 59.86 8.62801 59.412 9.44001L55.044 17L50.704 9.44001C50.284 8.62801 49.976 8.60001 48.856 8.60001H46.896C46.196 8.60001 46.084 9.02001 46.392 9.55201L53.252 20.584V27.528C53.252 28.228 53.476 28.48 54.204 28.48H55.8C56.5 28.48 56.752 28.228 56.752 27.528V20.64L63.584 9.55201C63.892 9.02001 63.808 8.60001 63.108 8.60001Z",
    fill: "#0C0C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4099 19.156V23.3C63.4099 26.772 65.7059 28.9 69.8499 28.9C74.0499 28.9 76.3179 26.772 76.3179 23.3V19.156C76.3179 15.684 74.0499 13.556 69.8499 13.556C65.7059 13.556 63.4099 15.684 63.4099 19.156ZM73.0699 19.156V23.3C73.0699 24.98 71.9219 25.96 69.8499 25.96C67.8059 25.96 66.6579 24.98 66.6579 23.3V19.156C66.6579 17.448 67.8059 16.496 69.8499 16.496C71.9219 16.496 73.0699 17.448 73.0699 19.156Z",
    fill: "#0C0C0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.965 14.508C80.069 14.872 79.873 15.208 79.873 16.104V27.612C79.873 28.256 80.097 28.48 80.741 28.48H82.281C82.925 28.48 83.121 28.256 83.121 27.612V17.168C83.121 17.056 83.177 16.944 83.317 16.888C84.045 16.692 84.913 16.524 86.005 16.524C88.049 16.524 89.057 17.42 89.057 19.268V27.612C89.057 28.256 89.253 28.48 89.897 28.48H91.437C92.081 28.48 92.305 28.256 92.305 27.612V19.184C92.305 15.628 90.457 13.556 86.481 13.556C83.793 13.556 82.085 14.06 80.965 14.508Z",
    fill: "#0C0C0C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7415 19.604V22.908C95.7415 26.352 97.5895 28.9 102.182 28.9C105.346 28.9 107.222 27.864 108.23 26.212C108.622 25.596 108.538 25.12 107.894 24.812L106.914 24.28C106.242 23.916 105.934 24 105.486 24.616C104.898 25.54 103.834 26.1 102.182 26.1C100.138 26.1 98.9895 25.12 98.9895 23.3V22.264H107.446C108.426 22.264 108.706 21.788 108.706 21.06V19.352C108.706 16.132 106.69 13.556 102.238 13.556C98.0095 13.556 95.7415 15.712 95.7415 19.604ZM105.458 19.156V19.772H98.9895V19.156C98.9895 17.336 100.138 16.3 102.238 16.3C104.366 16.3 105.458 17.336 105.458 19.156Z",
    fill: "#0C0C0C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.549 13.976H122.037C121.393 13.976 121.169 14.172 121.169 14.816V24.84C120.413 25.036 119.461 25.232 118.285 25.232C116.241 25.232 115.233 24.336 115.233 22.46V14.816C115.233 14.172 115.037 13.976 114.393 13.976H112.853C112.209 13.976 111.985 14.172 111.985 14.816V22.572C111.985 26.1 113.833 28.2 117.837 28.2C119.209 28.2 120.301 28.004 121.169 27.808V29.124C121.169 31.112 120.161 32.148 118.201 32.148C116.689 32.148 115.849 31.644 115.261 30.72C114.841 30.132 114.533 30.048 113.861 30.384L112.797 30.972C112.125 31.308 112.041 31.756 112.433 32.372C113.441 34.024 115.233 35.06 118.257 35.06C122.653 35.06 124.417 32.624 124.417 28.956V14.816C124.417 14.172 124.193 13.976 123.549 13.976Z",
    fill: "#0C0C0C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_3047_21073)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5988 5.33453C33.7943 5.51595 33.9863 5.70123 34.1744 5.89026L7.21473 32.85L6.64905 32.2843L33.5988 5.33453Z",
    fill: "#34159D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C8.9543 40 0 31.0457 0 20C0 14.4772 2.23857 9.47717 5.85786 5.85788L20 20V40Z",
    fill: "url(#paint1_linear_3047_21073)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1421 5.85788C37.7614 9.47717 40 14.4772 40 20C40 31.0457 31.0457 40 20 40V20L34.1421 5.85788Z",
    fill: "url(#paint2_linear_3047_21073)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2 39.9843C19.4654 39.9947 19.7321 40 20 40L20 20L19.2 19.2V39.9843Z",
    fill: "url(#paint3_linear_3047_21073)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8 39.9843C20.5346 39.9947 20.2679 40 20 40L20 20L20.8 19.2V39.9843Z",
    fill: "url(#paint4_linear_3047_21073)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1421 5.85788L20 20V21.1314L34.6966 6.4348C34.5156 6.23883 34.3307 6.04648 34.1421 5.85788Z",
    fill: "url(#paint5_linear_3047_21073)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3.73334L20 13.8667C23.3873 13.8667 26.1333 16.6127 26.1333 20L36.2667 20C36.2667 11.0162 28.9838 3.73334 20 3.73334",
    fill: "url(#paint6_linear_3047_21073)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3.73334C11.0162 3.73334 3.73334 11.0162 3.73334 20L13.8667 20C13.8667 16.6127 16.6126 13.8667 20 13.8667L20 3.73334Z",
    fill: "url(#paint7_linear_3047_21073)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2667 20C36.2667 28.9838 28.9838 36.2667 20 36.2667L20 26.1333C23.3873 26.1333 26.1333 23.3873 26.1333 20L36.2667 20Z",
    fill: "url(#paint8_linear_3047_21073)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 36.2667L20 26.1333C16.6126 26.1333 13.8667 23.3873 13.8667 20L3.73334 20C3.73334 28.9838 11.0162 36.2667 20 36.2667Z",
    fill: "url(#paint9_linear_3047_21073)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3047_21073",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A43EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F17CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3047_21073",
    x1: -3.49345e-7,
    y1: 5.86667,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FACD81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD79E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3047_21073",
    x1: 40,
    y1: 5.86667,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC39A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#F58F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D65F40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3047_21073",
    x1: 19.6,
    y1: 19.2,
    x2: 19.6,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE39C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE8BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3047_21073",
    x1: 20.4,
    y1: 19.2,
    x2: 20.4,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE4A2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3047_21073",
    x1: 20,
    y1: 20,
    x2: 34.2667,
    y2: 5.86667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB78C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDBB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3047_21073",
    x1: 20,
    y1: 13.8667,
    x2: 26.1333,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3047_21073",
    x1: 13.8667,
    y1: 20,
    x2: 20,
    y2: 13.7333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3047_21073",
    x1: 20,
    y1: 30.1333,
    x2: 26.4,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3047_21073",
    x1: 20,
    y1: 31.0667,
    x2: 13.7333,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.513fb4a509431493454f70a19dbcb301.svg";
export { ForwardRef as ReactComponent };